import { calculateRiskRating, getContrastColor } from "../../helpers/riskHelper";

const RiskRatingDisplay = ({ probability, severity, riskMatrix }) => {
  if (!riskMatrix || !probability || !severity) return null;

  const rating = calculateRiskRating(probability, severity, riskMatrix);
  const color = riskMatrix.colors[rating] || "#000000";
  const textColor = getContrastColor(color);

  return (
    <div
      className="mt-2 p-2 rounded text-center"
      style={{
        backgroundColor: color,
        color: textColor,
      }}
>
      Risk Rating: {rating}
    </div>
  );
};

export default RiskRatingDisplay;
